import React from 'react';
import { Card, Badge } from '@/components/ui';
import type { SupportTicket } from '../../types/dashboard.types';

interface RecentTicketsWidgetProps {
  tickets: SupportTicket[];
}

export function RecentTicketsWidget({ tickets }: RecentTicketsWidgetProps) {
  return (
    <Card className="p-6 border-slate-100 shadow-sm flex flex-col h-[280px]">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-medium text-slate-900">Yêu cầu hỗ trợ mới</h3>
        <button className="sm:text-sm text-xs font-medium text-emerald-600 hover:text-emerald-700">Xem tất cả</button>
      </div>

      <div className="flex-1 flex flex-col justify-center gap-5">
        {tickets.map((ticket, index) => (
          <div key={index} className="flex items-center justify-between">
            <div className="flex items-start gap-3">
              <div className={`mt-1 w-2 h-2 rounded-full bg-${ticket.color}-500 ring-4 ring-${ticket.color}-50`} />
              <div>
                <p className="sm:text-sm text-xs font-medium text-slate-800 line-clamp-1 mb-0.5">{ticket.title}</p>
                <p className="sm:text-sm text-xs text-slate-500">{ticket.tenant}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <Badge variant="custom" className={`bg-${ticket.color}-50 text-${ticket.color}-600 border-${ticket.color}-100 px-2 py-0 sm:text-sm text-xs`}>
                {ticket.priority}
              </Badge>
              <span className="sm:text-sm text-xs text-slate-400 font-mono">{ticket.created_at}</span>
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}
